import React, { useContext, useEffect, useState } from "react";
import cityApi from "../../../api/cityApi";
import RtlProvider from "../../../Components/RtlProvider";
import { Paper, Typography } from "@mui/material";
import { ContextUserInfo } from "../MainPanel";
import AccessControl from "../../../Components/AccessControl";

const CityPanel = () => {
  const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
  const [rows, setRows] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loadingRows, setLoadingRows] = useState(false);
  const columns = [
    { field: "name", headerName: "نام شهر" },
    { field: "isActive", headerName: "فعال", type: 'boolean' }
  ];
  useEffect(() => {
    GetData();
  }, [refresh]);

  const RefreshGrid = (result) => {
    if (result)
      setRefresh(old => !old);
  }
  const GetData = () => {
    setLoadingRows(true);
    cityApi.GetAll()
      .then((data) => {
        setRows(data.data.data)
      })
      .catch((error) => console.log(error)).finally(() => setLoadingRows(false));
  };

  return (
    <RtlProvider>
      <Typography component="h1" variant="h5" mb={2}>
        لیست شهر
      </Typography>
      <Paper sx={{ width: "100%", height: "600px" }}>
      </Paper>
    </RtlProvider>
  );
}

export default CityPanel;
